import React, { useState, useEffect } from "react";
import { message, Button, Switch, Checkbox, Modal, Radio } from "antd";
import { Form } from "antd";
import styled from "@emotion/styled";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { connect } from "react-redux";
import { setBreakTypesList, setLeaveCategoryList } from "redux/actions";
import { bindActionCreators } from "redux";
import {
  getLocations,
  getClientid,
  getAllDepartmentList,
} from "redux/selectors";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import StepsProgress from "./StepsProgress";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SelectTable from "molecules/SelectTable";
import { getAddLeaveJson } from "JsonFormat/LeaveJson";
import InReview from "molecules/InReview";
import FormModal from "./FormModal";
import PublishLeaveModal from "./PublishLeaveModal";
import moment from "moment";

const AddLeaves = ({
  closeModal,
  ClientId,
  saveLeaveCategoryList,
  departmentList,
  locationList,
  getLeaveList,
  LeaveList,
}) => {
  const [showLoader, toggleLoader] = useState(false);
  const [form] = Form.useForm();

  const filterLocationList = locationList?.filter(
    (item) => item?.login_from_anywhere !== 1
  );

  console.log("leaveList--->", LeaveList);

  const fetchMasterData = async (fetch_master_data) => {
    const { code, leaveCategories } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      saveLeaveCategoryList(leaveCategories);
    }
  };

  const [data, setData] = useState({});
  console.log("data132--->", data);
  const [showPopup, setShowPopup] = useState(false);
  const { AddLeaveForm } = getAddLeaveJson(data, LeaveList, setShowPopup);
  const [step, setStep] = useState(0);
  const [selectDepartmentId, setSelectDepartmentId] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [openDepartmentModal, setOpenDepartmentModal] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectAllDepartmentChecked, setSelectAllDepartmentChecked] =
    useState(false);
  const [publishOpen, setPublishOpen] = useState(false);

  useEffect(() => {
    setSelectAllDepartmentChecked(
      selectDepartmentId?.length === departmentList?.length
    );
    setSelectAllChecked(
      selectedLocationId?.length === filterLocationList?.length
    );
  }, [selectDepartmentId, departmentList, selectedLocationId, locationList]);

  const handleFormChange = (e) => {
    console.log("event", e);
    if (e.target.name === "accrual") {
      setShowPopup(true);
    }

    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setData((prevData) => ({
      ...prevData,
      // accrual: "No",
      // accrualtype: "Monthly",
      rollout: "No",
    }));
  }, []);

  const reviewData = () => {
    const { isSaturday, ...rest } = data; // Destructure isSaturday
    const updatedObject = {
      ...rest, // Spread the remaining properties
      saturday: isSaturday, // Add the new key with its value
    };
    return updatedObject;
  };

  const handleSubmitForm = (e) => {
    setStep(1);
  };

  const stepdata = [
    { id: 1, title: "Basic" },
    { id: 2, title: "Department" },
    { id: 3, title: "Location" },
    { id: 4, title: "Review" },
  ];

  const departmentcolumns = [
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id, record) => {
        return (
          <Switch
            size="small"
            checked={
              selectAllDepartmentChecked ||
              selectDepartmentId.includes(department_id)
            }
            onChange={(checked) => getDepartmentId(department_id, checked)}
          />
        );
      },
    },
  ];

  const getDepartmentId = (department_id, checked) => {
    const newDepartmentId = checked
      ? [...selectDepartmentId, department_id]
      : selectDepartmentId.filter((item) => item !== department_id);
    setSelectDepartmentId(newDepartmentId);
  };

  const handleSelectAllDepartment = (e) => {
    const checked = e.target.checked;
    setSelectAllDepartmentChecked(checked);
    const allDepartmentIds = departmentList.map((item) => item.department_id);
    setSelectDepartmentId(checked ? allDepartmentIds : []);
  };

  const locatincolumns = [
    {
      title: "Location Name",
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id, record) => {
        return (
          <Switch
            size="small"
            checked={
              selectAllChecked || selectedLocationId.includes(location_id)
            }
            onChange={(checked) => getLocationId(location_id, checked)}
          />
        );
      },
    },
  ];

  const getLocationId = (location_id, checked) => {
    const newLocationId = checked
      ? [...selectedLocationId, location_id]
      : selectedLocationId.filter((item) => item !== location_id);
    setSelectedLocationId(newLocationId);
  };

  const handleSelectAllLocation = (e) => {
    const checked = e.target.checked;
    setSelectAllChecked(checked);
    const allLocationIds = filterLocationList.map((item) => item.location_id);
    setSelectedLocationId(checked ? allLocationIds : []);
  };

  const onFinish = async (isPublish = false) => {
    try {
      toggleLoader(true);
      const {
        eligible,
        leave_category_name,
        number_of_leaves,
        weekend,
        holiday,
        isSaturday,
        accrualtype,
        expiry_date,
        accrual,
        rollout,
        reliever,
      } = data;
      const { code } = await CALL_API(`owner-leave/${ClientId}`, "post", {
        // allocation: "YEARLY",
        eligible: eligible,
        leavecategoryname: leave_category_name,
        numberofleaves: number_of_leaves,
        department: selectDepartmentId,
        location: selectedLocationId,
        weekend: weekend,
        holiday: holiday,
        publishedstatus: isPublish,
        isSaturday: isSaturday,
        accrualtype: accrual === "No" ? "Yearly" : accrualtype,
        // expiry_date: moment(expiry_date).format("MMMM YYYY") ?? null,
        expiry_date:
          rollout === "Yes"
            ? expiry_date
              ? moment(expiry_date)
                  .endOf("month")
                  .format("MMMM")
                  .charAt(0)
                  .toUpperCase() +
                moment(expiry_date)
                  .endOf("month")
                  .format("MMMM")
                  .slice(1)
                  .toLowerCase()
              : moment()
                  .add(1, "year")
                  .endOf("year")
                  .format("MMMM")
                  .charAt(0)
                  .toUpperCase() +
                moment()
                  .add(1, "year")
                  .endOf("year")
                  .format("MMMM")
                  .slice(1)
                  .toLowerCase()
            : null,
        accrual: accrual,
        rollout: rollout,
        reliever: reliever,
      });
      if (code === STATUS_CODE.SUCCESS) {
        toggleLoader(false);
        fetchMasterData();
        setData({});
        setSelectDepartmentId([]);
        setSelectedLocationId([]);
        closeModal(true);
        setStep(0);
        message.success("Successfully Added");
        getLeaveList();
      }
    } catch (error) {
      toggleLoader(false);
      console.error("An error occurred:", error);
      // Handle error, maybe show a notification to the user or perform other actions
    }
  };

  return (
    <>
      <>
        <label
          className="bg-transparent border-0 mb-3 text-left styled-cursor"
          onClick={() => closeModal(false)}
        >
          Leave <ArrowForwardIosIcon className="px-1" />
        </label>{" "}
        <b className="pb-0 pt-1">Add Leave</b>
        <StepsProgress stepdata={stepdata} title="Add Leave:" step={step} />
        {AddLeaveForm && (
          <div className="styled-card">
            {step === 0 && (
              <>
                <GridBuilder
                  formStructureJson={AddLeaveForm}
                  handleChange={handleFormChange}
                  formSubmit={handleSubmitForm}
                  initialValues={data}
                />
              </>
            )}

            {step === 1 && (
              <>
                {departmentList?.length > 0 && (
                  <Checkbox
                    className="mt-3"
                    checked={selectAllDepartmentChecked}
                    onChange={handleSelectAllDepartment}
                  >
                    Select All
                  </Checkbox>
                )}

                <SelectTable
                  step={step}
                  setStep={setStep}
                  columns={departmentcolumns}
                  tabledata={departmentList}
                  setOpenModal={() => setOpenDepartmentModal(true)}
                  Name="Add Department"
                />
                <FormModal
                  isModalVisible={openDepartmentModal}
                  closeModal={() => setOpenDepartmentModal(false)}
                  Name="Department"
                />
              </>
            )}

            {step === 2 && (
              <>
                {filterLocationList?.length > 0 && (
                  <Checkbox
                    className="mt-3"
                    checked={selectAllChecked}
                    onChange={handleSelectAllLocation}
                  >
                    Select All
                  </Checkbox>
                )}

                <SelectTable
                  step={step}
                  setStep={setStep}
                  columns={locatincolumns}
                  tabledata={filterLocationList}
                  setOpenModal={() => setOpenLocationModal(true)}
                  Name="Add Location"
                />
                <FormModal
                  isModalVisible={openLocationModal}
                  closeModal={() => setOpenLocationModal(false)}
                  Name="Location"
                />
              </>
            )}
            {step === 3 && (
              <InReview
                step={step}
                setStep={setStep}
                BasicInformation={reviewData()}
                department={selectDepartmentId}
                location={selectedLocationId}
                create={() => setPublishOpen(true)}
                // loading={showLoader}
              />
            )}
          </div>
        )}
      </>
      <PublishLeaveModal
        isModalOpen={publishOpen}
        handleCancel={() => setPublishOpen(false)}
        handleOk={onFinish}
        loading={showLoader}
      />

      <Modal
        // title="Leave Settings"
        header={null}
        open={showPopup}
        onCancel={() => setShowPopup(false)}
        footer={null}
        centered
        maskClosable={false}
      >
        <div style={{ marginBottom: 16 }}>
          <label
            style={{
              fontWeight: 500,
              fontSize: 16,
              display: "block",
              marginBottom: 8,
            }}
          >
            <span style={{ color: "red", marginRight: 4 }}>*</span>
            Do you want to roll over this leave to next year?
          </label>

          <Radio.Group
            value={data?.rollout}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                rollout: e.target.value,
                expiry_date: e.target.value === "No" ? null : prev.expiry_date,
              }));
              setShowPopup(false);
            }}
          >
            <Radio value={"Yes"}>Yes</Radio>
            <Radio value={"No"}>No</Radio>
          </Radio.Group>
        </div>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => ({
  ClientId: getClientid(state),
  locationList: getLocations(state),
  departmentList: getAllDepartmentList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setBreakTypes: setBreakTypesList,
      saveLeaveCategoryList: setLeaveCategoryList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps, null)(AddLeaves);
